import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="h-4 w-4 animate-spin rounded-full border-2 border-t-2 border-white border-t-transparent"></div>
    </div>
  );
};

export default LoadingSpinner;
